module.exports = __webpack_public_path__ + "static/media/no-image.8db20e23.svg";